module.exports = __webpack_public_path__ + "img/Priest-undead-m-70.57d71976.gif";